import { useEffect, useState } from "react";
import { getUserCountry } from "../../utils/utils";
import ReactMarkdown from "react-markdown";
import Button from "../Shared/Button";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../main";
import { ApiError } from "../../types/ApiError";
import { toast } from "react-toastify";
import { AddPackageToCart } from "../../api/Cart/AddPackageToCart";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

interface PackageCardProps {
    packages: {
        id: string;
        name: string;
        img_url: string;
        description: string;
        discountPercentage: number;
        actualPrice_egp: string;
        actualPrice_usd: string;
        discountPrice_usd: string;
        discountPrice_egp: string;
        courses: {
            id: string;
            name: string;
            img_url: string;
            actualPrice_egp: string;
            actualPrice_usd: string;
        }[];
    };
}

const PackageCard = ({ packages }: PackageCardProps) => {
    const navigate = useNavigate()

    const [country, setCountry] = useState<string | null>(null);
    const { mutate } = useMutation({
        mutationFn: () => AddPackageToCart(packages.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["cart"] });
        },
        onError: (error: unknown) => {
            const apiError = error as ApiError;
            if (apiError?.response?.data.statusCode === 400) {
                toast.error(apiError?.response?.data.message);
            } else {
                toast.error("Error Adding To Cart");
            }
        },
    });

    useEffect(() => {
        const userCountry = getUserCountry();
        setCountry(userCountry);
    }, []);
    const handleBuyNowClick = () => {
        const accessToken = Cookies.get("accessToken");
        if (accessToken) {
            mutate();
        } else {
            navigate("/login?cart=true");
        }
    };

    return (
        <div className="p-4 bg-white rounded-2xl border border-black/20 relative flex h-full flex-col justify-between w-full">
            <div className="relative mb-4 w-full">

                            <img
                                src={packages.img_url}
                                className='object-cover h-[225px] w-full rounded-lg'
                            />

                {packages.discountPercentage !== 0 &&
                    <>
                        {country === 'EG' ? (
                            <>
                                {packages.discountPrice_egp && (
                                    <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                                        {packages.actualPrice_egp} EGP
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                {packages.discountPrice_usd && (
                                    <div className="absolute px-2 border-red-700 h-7 border text-red-500 line-through bg-white bottom-[26px] font-semibold right-px rounded-tr rounded-br flex justify-center items-center md:text-base text-sm">
                                        {packages.actualPrice_usd} USD
                                    </div>
                                )}
                            </>
                        )}
                    </>
                }

            </div>

            <div>
                <div className="flex justify-between w-full items-center mb-3 py-0.5">
                    <h1 className="font-semibold md:text-2xl sm:text-xl text-lg">{packages.name}</h1>

                    <div className="rounded py-1.5 min-w-[90px] px-3 flex justify-center items-center gap-0.5 font-bold bg-primary text-white">
                        {country === "EG" ? (
                            <>
                                {packages.discountPrice_egp} <span className="text-sm uppercase">EGP</span>
                            </>
                        ) : (
                            <>
                                {packages.discountPrice_usd} <span className="text-sm uppercase">USD</span>
                            </>
                        )}
                    </div>
                </div>
                <div className=" mb-4">
                    <span className="font-medium sm:text-sm text-xs text-lightGray/70">
                        <ReactMarkdown>{packages.description}</ReactMarkdown>
                    </span>
                </div>
                <Button
                    variant="gray"
                    className="md:h-9 h-8 !rounded-lg font-semibold text-xs w-full"
                    onClick={handleBuyNowClick}
                >
                    Add To Cart
                </Button>

            </div>
        </div>
    );
};

export default PackageCard;
